module.exports = {
  apiHost: "https://api.springwood.sensoreal.com.au",
  assetsHost: "https://assets.springwood.sensoreal.com.au",
  contact: {
    address: "Springwood Sales Centre<br>Easton Drive, Gawler East",
    email: "",
    phone: "1800 224 551",
    website: "https://myspringwood.com.au",
  },
  header: {
    logo:
      "https://assets.springwood.sensoreal.com.au/misc/welco-logo-white.png",
    text: {
      en: "Your Springwood Selections",
      ar: "",
    },
    color: "#fff",
  },
  langs: [{ code: "en", dir: "ltr" }],
  links: {
    instagram: "",
    facebook: "https://www.facebook.com/myspringwood/",
    linkedin: "https://www.instagram.com/myspringwood/",
    privacy: "",
    twitter: "",
    youtube: "",
  },
  style: {
    primaryColor: "#c75d42",
    textColor: "#fff",
  },
};
